(function () {
    'use strict';

    angular.module("imApp").factory("componentAlternativeService", ['$ihttp', function ($ihttp) {
        let service = {
            getComponentAlternative: function (parms) {
                return $ihttp.post({
                    method: 2404,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2405,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 2406,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
